// extracted by mini-css-extract-plugin
export var link = "NavbarItem-module--link--KEGWg";
export var menuItem = "NavbarItem-module--menuItem--20FKB";